// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__NC1AO","productName":"Table_productName__3tvtK"};